/* eslint-disable no-undef */
import React from 'react';
import { ReactTypeformEmbed } from 'react-typeform-embed';

const {
  tagsJson,
} = require('./tags/abbottlyon/tags');

const getTypeFormUrl = newInfluencer => {
  const { id, attributes: { name, email, instagram, tiktok, country } } = newInfluencer;
  const baseUrl = 'https://dyzio.typeform.com/to/Tz1F9ciO';
  let typeFormUrl = `${baseUrl}?user_id=${id}&name=${encodeURIComponent(name)}&email=${encodeURIComponent(email)}`;
  typeFormUrl += `&instagram=${instagram}&tiktok=${tiktok}&country=${country}`;
  console.log(typeFormUrl);
  return typeFormUrl;
};

const logoStyle = {
  height: 60,
  display: 'block',
  margin: '0 auto',
};

const minHeight200 = {
  'min-height': '200px',
};

const textAlignCentre = {
  'text-align': 'center',
};

const landingImg = {
  margin: 'auto',
  width: '50%',
  height: 'auto',
  display: 'flex',
};

const textAlignCentre50p = {
  'text-align': 'center',
  padding: '0 50px',
};

const ABBOTTLYONTheme = {
  headerLogo: {
    src: '/themes/theme/abbottlyon/logo.png',
    alt: 'Abbott Lyon',
  },
  darkLogo: {
    src: '/themes/theme/abbottlyon/logo.png',
    alt: 'Abbott Lyon',
  },
  headerStyle: {
    backgroundColor: '#EEDDD5',
    borderBottom: '2px solid #FDF5ED',
  },
  linkStyle: {
    color: '#fff',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'Abbott Lyon',
  tagsTitle: () => (
    <h3 style={textAlignCentre}>Tell us more about yourself ...</h3>
  ),
  tagsHtmlTop: () => (
    <h3 style={textAlignCentre}>How would you describe your content style? (please select at least one)</h3>
  ),
  socialHandle1HtmlTitle: () => (
    <h3 style={textAlignCentre}>Your Socials</h3>
  ),
  socialHandle2HtmlTitle: () => (
    <h3 style={textAlignCentre}>Your Socials</h3>
  ),
  socialHandle3HtmlTitle: () => (
    <h3 style={textAlignCentre}>Your Socials</h3>
  ),
  confirmationTitle: () => (
    <h3 style={textAlignCentre}>One last step (nearly there!)</h3>
  ),
  signUpTitle: () => (
    <h3 style={textAlignCentre}>What happens now?</h3>
  ),
  instagramLabel: 'Instagram Handle (1,000+ Followers)',
  tiktokLabel: 'Tiktok Handle (1,000+ Followers)',
  dobLabel: 'Date of birth (You must be 18+ to sign up)',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/abbottlyon/logo.png" alt="Abbott Lyon" />
    </div>
  ),
  shareSite: 'https://reporting.abbottlyon.com',
  organisationId: '6b7ed405-e8ef-4b8d-9515-f09108e9e367',
  dobRequired: true,
  primaryButtonColorStyle: {
    background: '#EEDDD5',
    color: 'black',
    margin: 5,
  },
  tagButtonColor: 'pink',
  skipAdditionalHandles: true,
  skipMainHandles: true,
  tAndCUrl: '/themes/theme/abbottlyon/AL_terms.pdf',
  ppUrl: 'https://www.abbottlyon.com/pages/privacy-policy',
  useLogoOnPreview: true,
  hideLastCheckbox: false,
  formTitle: () => (
    <h3 style={textAlignCentre}>Join the Abbott Lyon Gifting Programme!</h3>
  ),
  personalDetailHtmlBottom: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre50p}>Personal Email Address
      (Don't worry, this will not be shared with any third parties for marketing purposes!)</p>
      <br />
    </div>
  ),
  welcomeHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>Create your profile</p>
      <br />
      <p style={textAlignCentre50p}>Simply fill in our submission form (This should not take more than five minutes!).
      Our team members will then review your profile and get back to you soon.</p>
      <br />
      <img
        style={landingImg}
        src="/themes/theme/abbottlyon/abbottlyon_signup.png" alt="Abbott Lyon"
      />
    </div>
  ),
  signUpHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>- Please note that this Gifting Programme is only available for UK, Ireland,
      and USA residents only.
      </p>
      <br />
      <p style={textAlignCentre}>- A member of the Abbott Lyon team will review your profile. If successful
      you will be welcomed onboard to our Gifting Programme (We can't wait to work together). If not,
      don't worry we will provide you with top tips on how to improve your profile to be considered again in the
      future.
      </p>
      <br />
      <p style={textAlignCentre}>- If successful, you will receive free Abbott Lyon jewellery and if you love it
      (which we are sure you will), we encourage you to share this on your social media platform (Don't worry,
      we will keep you up to date with the beautiful pieces that you will receive and any instructions that you
      need to follow!)
      </p>
      <br />
    </div >
  ),
  finishedHtml: () => (
    <div style={minHeight200}>
      <p style={textAlignCentre}>You're all set!</p>
      <br />
      <p style={textAlignCentre}>Thank you for your submission! Please remember to fill in the form below and you can expect to receive an email
      from us soon.</p>
      <br />
    </div>
  ),
  typeForm: newInfluencer => (
    <div style={minHeight200}>
      {
        newInfluencer && newInfluencer.id &&
          <ReactTypeformEmbed url={getTypeFormUrl(newInfluencer)} />
      }
    </div>
  ),
  extraCheckboxHtml: () => (
    <div style={{ marginLeft: 10 }}>
      <p>I accept the usage rights</p>
      <p style={{ fontSize: '80%', color: 'grey' }}>(Want more followers?<br />Discover
      the benefits of allowing usage rights <a
        target="_blank"
        rel="noopener noreferrer"
        href="/themes/theme/abbottlyon/benefits.pdf"
      >here</a>)
      </p>
    </div>
  ),
  tagsJson,
  tiktokOnFrontPage: true,

};

export default ABBOTTLYONTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/abbottlyon.js
 **/